import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const Stats = (props) => {
  const { children, listClassName } = props;

  return (
    <ul className={`${styles.listStats} ${listClassName || ''}`}>
      {React.Children.map(
        children,
        (child) => (child && <li key={child.label}>{child}</li>) || ''
      )}
    </ul>
  );
};

Stats.propTypes = {
  children: PropTypes.node.isRequired,
  listClassName: PropTypes.string
};

Stats.defaultProps = {
  listClassName: null
};

export default Stats;
